import { createReducer } from 'redux-act';
// project files
import { PAGINATION_TYPES } from 'utils/constants';
import * as actions from './actions';

const paginateObj = {
  limit: 0,
  total: 0,
  data: [],
  skip: 0,
};

const initialState = {};

Object.keys(PAGINATION_TYPES).map(
  (key) => (initialState[PAGINATION_TYPES[key]] = { ...paginateObj })
);

const paginationReducer = createReducer(
  {
    [actions.pagePaginationSuccess]: (state, payload) => {
      return {
        ...state,
        [payload.key]: payload.data,
      };
    },
    [actions.updatePaginationItem]: (state, payload) => {
      const items = [...state[payload.key].data];
      const currentIndex = items.findIndex((item) => item._id === payload.id);
      if (currentIndex === -1) return state;
      items[currentIndex] = {
        ...items[currentIndex],
        ...payload.data,
      };

      return {
        ...state,
        [payload.key]: {
          ...state[payload.key],
          data: items,
        },
      };
    },
    [actions.deletePaginationItem]: (state, payload) => {
      return {
        ...state,
        [payload.key]: {
          ...state[payload.key],
          data: state[payload.key].data.filter((item) => item._id !== payload.value),
          total: state[payload.key].total - 1,
        },
      };
    },
    [actions.addPaginationItem]: (state, payload) => {
      return {
        ...state,
        [payload.key]: {
          ...state[payload.key],
          data: [payload.value, ...state[payload.key].data],
          total: state[payload.key].total + 1,
        },
      };
    },
    [actions.toggleGlobalItem]: (state, payload) => {
      const data = state[payload.key].data.map((item) => {
        item[payload.data.key] =
          item._id === payload.id ? payload.data.value : payload.data.oldValue;

        return item;
      });

      return {
        ...state,
        [payload.key]: {
          ...state[payload.key],
          data,
        },
      };
    },
    [actions.fetchStudentPreferenceInstructorSuccess]: (state, payload) => ({
      ...state,
      preferenceInstructor: payload,
    }),
  },
  initialState
);

export default paginationReducer;
